import { render } from "./AuthPageView.vue?vue&type=template&id=f224dece"
import script from "./AuthPageView.vue?vue&type=script&lang=js"
export * from "./AuthPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__